import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const [storyExpanded, setStoryExpanded] = useState(false);
  return <section className="bg-gradient-section px-4 py-12 md:px-8 md:py-16" style={{
    paddingTop: "0px"
  }} data-id="element-259" data-mp="38vu7s8uzq744">
      <div className="mx-auto max-w-3xl space-y-14" data-id="element-260" data-mp="2v08evqlmz36f">

        {/* Eyebrow */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-[12px] font-semibold uppercase tracking-[0.28em] text-[#C8A870] md:text-[13px]" data-id="element-261" data-mp="2yy63osbhvn9a">
          Una historia que podría ser la tuya
        </motion.p>

        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium relative overflow-hidden p-6 md:p-10" style={{
        paddingTop: "20px"
      }} data-id="element-262" data-mp="2g9sm9qqw4sy8">
          {/* Línea lateral */}
          <div className="absolute bottom-0 left-0 top-0 w-[2px] bg-gradient-to-b from-transparent via-gold/60 to-transparent" data-id="element-263" data-mp="3nlflucugr43b" />

          <div className="pl-3 md:pl-6" data-id="element-264" data-mp="5g2k4loy5mo8">

            {/* Historia colapsable */}
            <div className={`relative overflow-hidden transition-[max-height] duration-500 ease-out ${storyExpanded ? 'max-h-[1400px]' : 'max-h-[330px]'}`} data-id="element-265" data-mp="gzgn5om7oid">
              <div className="space-y-5 md:space-y-6" data-id="element-266" data-mp="38wsu1bnngjv7">

                {/* Inicio */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-267" data-mp="33z160sq4lhwa">
                  María Elena tenía 49 años. Comía bien, caminaba, dormía
                  temprano.
                </p>

                {/* Situación */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-268" data-mp="2q59trcl0fjwv">
                  Pero algo ya no era igual. Su cintura cambió. Se despertaba
                  cansada. Y había días en los que no terminaba de sentirse
                  ella misma.
                </p>

                {/* Insight */}
                <p className="pt-1 font-body text-[17px] font-medium italic leading-[1.6] text-[#F0E8D8] md:text-[19px]" data-id="element-269" data-mp="u12a9loucv5c">
                  Durante mucho tiempo creyó que necesitaba esforzarse más.
                  Hasta que entendió algo: no estaba fallando; estaba
                  atravesando una etapa diferente.
                </p>

                {/* Nueva interpretación */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-270" data-mp="b4knzjsrhngh">
                  Lo que antes funcionaba no era necesariamente lo que más
                  necesitaba ahora. Su cuerpo le estaba dando nuevas señales,
                  y aprender a reconocerlas era el primer paso para acompañar
                  esa etapa de otra manera.
                </p>

                {/* Divider */}
                <div className="divider-fine !mt-7 w-full" data-id="element-271" data-mp="25ntaoaqhkn0n" />

                {/* H.E.R. */}
                <p className="font-body text-[16px] font-semibold text-[#C8A870] md:text-[17px]" data-id="element-272" data-mp="25pnkou07yupy">
                  Por eso necesitaba algo diferente: una forma de acompañar
                  esta etapa sin exigirse más.
                </p>

                <p className="font-body text-[16px] font-semibold text-[#C8A870] md:text-[17px]" data-id="element-273" data-mp="1rx7mq7m6dmvw">
                  Eso es lo que propone H.E.R.
                </p>
              </div>

              {/* Fade */}
              {!storyExpanded && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#120f0d] via-[#120f0d]/90 to-transparent" data-id="element-274" data-mp="1hwxb2rfsgniu" />}
            </div>

            {/* Toggle */}
            <div className="mt-5 flex justify-center" data-id="element-275" data-mp="18z4y3txjhrym">
              <button type="button" onClick={() => setStoryExpanded(value => !value)} aria-expanded={storyExpanded} className="inline-flex items-center gap-2 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C8A870] transition-opacity duration-300 hover:opacity-70" data-id="element-276" data-mp="37dolnzzor4wo">
                <span data-id="element-277" data-mp="3fdm8at6ujozn">
                  {storyExpanded ? 'Ocultar historia' : 'Leer la historia completa'}
                </span>

                <span className={`transition-transform duration-300 ${storyExpanded ? 'rotate-180' : ''}`} data-id="element-278" data-mp="31d1t07054baw">
                  ↓
                </span>
              </button>
            </div>
          </div>
        </motion.div>

      </div>
    </section>;
}